export default {
  stepNames: {
    incomes: 'incomes',
    expenses: 'expenses',
    summary: 'summary',
  },
};
